import client from "./axiosConfig";

export const getKPIs = (params) => {
  const config = {
    url: "/dashboard/kpi/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const getProjectCompletion = (params) => {
  const config = {
    url: `/dashboard/projects-completion/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getBillSummary = (params) => {
  const config = {
    url: `/dashboard/bills-summary/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const getBillSummaryByProjectId = (projectId) => {
  const config = {
    url: `/dashboard/bills-summary/${projectId}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const getBillSummaryBySiteId = (siteId) => {
  const config = {
    url: `/dashboard/sites-bills-summary/${siteId}/`,
    method: "GET",
  };
  return client(config);
};


export const getApprovals = (params) => {
  const config = {
    url: `/dashboard/approvals/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getCheckList = () => {
  const config = {
    url: `/dashboard/approvals/check-list/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const getAnnouncement = (params) => {
  const config = {
    url: `/dashboard/announcements/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getTaskSummary = (params) => {
  const config = {
    url: `/dashboard/task-summary/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getTaskKPI = (params) => {
  const config = {
    url: `/dashboard/task-kpis/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};